import React, { useCallback, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import TabPanel from 'src/components/TabPanel/TabPanel';
import { QuoteStatus } from 'src/utils/constants/quotes';
import { useDispatch, useSelector } from 'react-redux';
import { loadQuotes } from 'src/store/actions/quoteActions';
import QuotesList from 'src/views/userViews/quotes/QuotesList';
import AdminQuoteList from 'src/views/quotes/QuotesList';
import { useParams } from 'react-router-dom';
import Tab from 'src/components/Tab';
import { selectAuthSystem } from 'src/store/selectors/authSelectors';
import UserType from 'src/utils/constants/auth';

const selectTabs = tabIndex => {
  switch (tabIndex) {
    case 0:
      return QuoteStatus.IN_REVIEW;
    case 1:
      return QuoteStatus.DRAFT;
    case 2:
      return QuoteStatus.SENT;
    case 3:
      return QuoteStatus.SIGNATURE;
    case 4:
      return QuoteStatus.PAYMENT;
    case 5:
      return [QuoteStatus.CLOSED, QuoteStatus.ACCEPTED];
    case 6:
      return QuoteStatus.REJECTED;
    case 7:
      return QuoteStatus.ARCHIVED;
    default:
      return QuoteStatus.IN_REVIEW;
  }
};

const QuotesDetailListTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const system = useSelector(selectAuthSystem);

  const handleChangeTabs = useCallback(
    (_, newValue) => {
      setTabIndex(newValue);
      dispatch(
        loadQuotes({
          status: selectTabs(newValue),
          distributorProfileId: id
        })
      );
    },
    [setTabIndex]
  );

  return (
    <Box sx={{ flexGrow: 1, mt: '2rem' }}>
      <AppBar
        elevation={0}
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={tabIndex}
          onChange={handleChangeTabs}
        >
          <Tab
            label={t('ENUMS.QUOTE_STATUS.IN_REVIEW')}
            description={t('ENUMS.QUOTES_DESCRIPTION.CONTRACT_REQUESTS')}
          />
          <Tab
            label={t('ENUMS.QUOTE_STATUS.DRAFT')}
            description={t('ENUMS.QUOTES_DESCRIPTION.QUOTES')}
          />
          <Tab
            label={t('ENUMS.QUOTE_STATUS.SENT')}
            description={t('ENUMS.QUOTES_DESCRIPTION.SENT_QUOTES')}
          />
          <Tab
            label={t('ENUMS.QUOTE_STATUS.SIGNATURE')}
            description={t('ENUMS.QUOTES_DESCRIPTION.SIGNATURE_QUOTES')}
          />
          <Tab
            label={t('ENUMS.QUOTE_STATUS.PAYMENT')}
            description={t('ENUMS.QUOTES_DESCRIPTION.PAYMENT_QUOTES')}
          />
          <Tab
            label={t('ENUMS.QUOTE_STATUS.CLOSED')}
            description={t('ENUMS.QUOTES_DESCRIPTION.CLOSED_REQUESTS')}
          />
          <Tab
            label={t('ENUMS.QUOTE_STATUS.REJECTED')}
            description={t('ENUMS.QUOTES_DESCRIPTION.REJECTED_REQUESTS')}
          />
          <Tab
            label={t('ENUMS.QUOTE_STATUS.ARCHIVED')}
            description={t('ENUMS.QUOTES_DESCRIPTION.ARCHIVED_REQUESTS')}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={0} index={0}>
        {system === UserType.ADMIN ? <AdminQuoteList /> : <QuotesList />}
      </TabPanel>
    </Box>
  );
};

export default QuotesDetailListTabs;
